import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  appBar: {
    background: `linear-gradient(
      90deg,
      ${theme.palette.primary.dark} 0%,
      ${theme.palette.primary.light} 100%
    );`,
  },
  listItemText: {
    '& span': {
      fontFamily: theme.font.medium,
      fontSize: '18px',
    },
  },
  toastContainer: {
    width: '520px',
    height: 'auto',
    right: 'auto',
    zIndex: theme.zIndex.snackbar,
    '& .Toastify__toast--default': {
      background: 'transparent !important',
      boxShadow: `${theme.shadows[0]} !important`,
      '& svg': {
        position: 'absolute',
        transform: "translate('-50%', '-50%')",
        top: '50%',
        left: '50%',
      },
    },
  },
}));
